import React from "react";
import { ChevronUp, Plus } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom";
import { pathAddAccount } from "../../../common/config/vars";
import { $SiteColors } from "../../../common/config/company-atts";
interface IAccountListItem {
  setAccsShown: React.Dispatch<React.SetStateAction<boolean>>; //для установки состояние видимости списка аккаунтов
  accountNum: string; //номер аакаунта
  accsShown: boolean; //показан ли список аккаунтов
  accountsCount: number;
  addressOrOwnerFIO: string; //адрес
}

export const AccountsBlockTitle = ({
  setAccsShown,
  accountNum,
  accsShown,
  accountsCount,
  addressOrOwnerFIO
}: IAccountListItem) => {
  const history = useHistory();
  const canToggle = accountsCount > 1;
  return (
    <div
      className="data-card__accs_main"
      onClick={canToggle ? () => setAccsShown(!accsShown) : undefined}
      style={canToggle ? { cursor: "pointer" } : undefined}
    >
      <h2 className="data-card__title data-card__title_number">{accountNum}</h2>
      <p className="data-card__adress data-card__adress_active">{addressOrOwnerFIO}</p>
      {canToggle && (
        <span className="data-card__arrow-button" aria-hidden="true">
          <ChevronUp
            style={{
              transform: "rotateX(" + (accsShown ? "0deg" : "-180deg") + ")",
            }}
          />
        </span>
      )}
      <button
        className="data-card__add-acc-button"
        onClick={(e) => { e.stopPropagation(); history.push(pathAddAccount); }}
        title="Добавить лицевой счёт"
        style={{
          backgroundColor: $SiteColors.getState().backBtnSubmit,
          marginLeft: canToggle ? "20px" : "auto",
        }}
      >
        <Plus />
      </button>
    </div>
  );
};
